export default __webpack_public_path__ + "static/media/7.32.47d46434.jpg";